export const findSelectedCard = (value, cards) => {
  return cards.find(card => {
    const cardNumberNoSpaces = card.cardNumber.replace(/\s/g, ''); 
    const cardId = `${cardNumberNoSpaces.slice(0, 4)}${cardNumberNoSpaces.slice(-4)}`;
    return cardId === value.id; 
});
}